module.exports = __webpack_public_path__ + "img/logo-new2.8ec7abc7.png";